<template>
  <div>
    <log-chart :vars-ids="varsIds" />
  </div>
</template>

<script>
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import LogChart from '@/components/logging/LogChart';

export default {
  name: 'LogChartView',
  mixins: [
    BreadcrumbsManager,
  ],
  props: {
    varsIds: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.setBreadcrumbs([
      {
        text: `${this.$t('charts')} / ${this.$t('logging')}`,
        to: {
          name: 'logging-default',
        },
      },
      {
        text: `${this.$t('chart')}`,
      },
    ]);
  },
  components: {
    LogChart,
  },
};
</script>

<style scoped>

</style>
